import React from 'react';
import { Image as KonvaImage, Layer, Rect, Stage, Text } from 'react-konva';
import useKonvaImage from '../../hooks/useKonvaImage';

const COLORS = ['#E74C3C', '#3498DB', '#2ECC71', '#F39C12', '#9B59B6'];

export default function ReviewCanvas({ imageUrl, boxes }) {
  const { containerRef, image, display } = useKonvaImage(imageUrl);

  return (
    <div ref={containerRef} style={{ position: 'relative', lineHeight: 0, userSelect: 'none' }}>
      {display.w > 0 && (
        <Stage width={display.w} height={display.h} style={{ display: 'block' }}>
          <Layer>
            {image && (
              <KonvaImage image={image} x={0} y={0} width={display.w} height={display.h} />
            )}

            {(boxes || []).map((box, i) => {
              const color = COLORS[i % COLORS.length];
              const bx = box.x * display.w;
              const by = box.y * display.h;
              const bw = box.w * display.w;
              const bh = box.h * display.h;
              return (
                <React.Fragment key={i}>
                  <Rect
                    x={bx} y={by} width={bw} height={bh}
                    stroke={color} strokeWidth={2}
                    fill={color + '33'}
                    listening={false}
                  />
                  <Text
                    x={bx + 4} y={by + 4}
                    text={box.label}
                    fontSize={13} fontStyle="bold" fill="#fff"
                    shadowColor={color} shadowBlur={4}
                    listening={false}
                  />
                </React.Fragment>
              );
            })}
          </Layer>
        </Stage>
      )}
    </div>
  );
}
